module.exports = __webpack_public_path__ + "static/teaching-67645857894073f35799e753caa2e7fe.jpg";